import React, { Component } from "react";
import CartContext from "./CartContext";
import axios from "axios";
import { Table, Button, Modal, Form, Row, Col } from "react-bootstrap";

export default class BankAccountManagement extends Component {
  static contextType = CartContext;

  constructor(props) {
    super(props);
    this.state = {
      storeId: "",
      accounts: [],
      q: "",
      showModal: false,
      currentAccount: this.getEmptyAccount(),
    };
  }

  getEmptyAccount = () => ({
    id: "",
    bankName: "",
    address: "",
    ifsccode: "",
    accountName: "",
    accountNumber: "",
  });

  componentDidMount() {
    if (this.context.storeId) {
      this.setState({ storeId: this.context.storeId }, this.loadAccounts);
    }
  }

  loadAccounts = () => {
    const { storeId, q } = this.state;
    if (!storeId) return;

    let url = process.env.REACT_APP_API + `BankAccount/Store/${storeId}`;
    let params = {};
    // simple client-side filter param if your API later supports it
    if (q) params.q = q;

    axios
      .get(url, { params })
      .then((res) => this.setState({ accounts: res.data }))
      .catch((err) => console.error(err));
  };

  handleShowModal = (account = null) => {
    if (account) {
      this.setState({ currentAccount: { ...account }, showModal: true });
    } else {
      this.setState({
        currentAccount: this.getEmptyAccount(),
        showModal: true,
      });
    }
  };

  handleCloseModal = () => {
    this.setState({ showModal: false, currentAccount: this.getEmptyAccount() });
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({
      currentAccount: { ...this.state.currentAccount, [name]: value },
    });
  };

  handleSave = () => {
    const a = this.state.currentAccount;

    if (!a.bankName) {
      alert("Bank Name is required");
      return;
    }
    if (!a.accountName) {
      alert("Account Name is required");
      return;
    }
    if (!a.accountNumber) {
      alert("Account Number is required");
      return;
    }
    if (!a.ifsccode) {
      alert("IFSC Code is required");
      return;
    }
    if (!a.address) {
      alert("Address is required");
      return;
    }

    // Build payload explicitly
    const payload = {
      ...(a.id && { id: a.id }), // include id only when updating
      storeId: this.context.storeId, // REQUIRED for POST by your API
      bankName: a.bankName,
      address: a.address,
      ifsccode: a.ifsccode,
      accountName: a.accountName,
      accountNumber: a.accountNumber,
    };

    if (a.id) {
      // Update
      axios
        .put(process.env.REACT_APP_API + `BankAccount/${a.id}`, payload)
        .then(() => {
          this.setState((prev) => ({
            accounts: prev.accounts.map((x) =>
              x.id === a.id ? { ...x, ...payload } : x
            ),
            showModal: false,
          }));
        })
        .catch((err) => console.error(err));
    } else {
      // Create
      axios
        .post(process.env.REACT_APP_API + "BankAccount", payload)
        .then((res) => {
          const newAccount = res.data;
          this.setState((prev) => ({
            accounts: [...prev.accounts, newAccount],
            showModal: false,
          }));
        })
        .catch((err) => {
          alert(err);
        });
    }
  };

  handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this bank account?")) {
      axios
        .delete(process.env.REACT_APP_API + `BankAccount/${id}`)
        .then(() => this.loadAccounts())
        .catch((err) => console.error(err));
    }
  };

  handleFilterChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, this.loadAccounts);
  };

  render() {
    const { accounts, showModal, currentAccount, q } = this.state;

    // Client-side search (in case API doesn't filter by q)
    const filtered = q
      ? accounts.filter((a) => {
          const t = (s) => (s || "").toString().toLowerCase();
          const qq = q.toLowerCase();
          return (
            t(a.bankName).includes(qq) ||
            t(a.accountName).includes(qq) ||
            t(a.accountNumber).includes(qq) ||
            t(a.ifsccode).includes(qq) ||
            t(a.address).includes(qq)
          );
        })
      : accounts;

    return (
      <div className="container mt-1">
        <h3>
          <b>Bank Accounts</b>
        </h3>

        <Row className="mb-3 mt-3">
          <Col md={6}>
            <Form.Control
              name="q"
              placeholder="Search by bank/account/IFSC/address"
              value={q}
              onChange={this.handleFilterChange}
            />
          </Col>
          <Col md={3}>
            <Button variant="secondary" onClick={this.loadAccounts}>
              Refresh
            </Button>
          </Col>
          <Col md={3} className="text-md-end mt-2 mt-md-0">
            <Button variant="primary" onClick={() => this.handleShowModal()}>
              Add Bank Account
            </Button>
          </Col>
        </Row>

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Bank</th>
              <th>Account Name</th>
              <th>Account #</th>
              <th>IFSC</th>
              <th>Address</th>
              <th style={{ width: 140 }}>Actions</th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((a) => (
              <tr key={a.id}>
                <td>{a.bankName}</td>
                <td>{a.accountName}</td>
                <td>{a.accountNumber}</td>
                <td>{a.ifsccode}</td>
                <td>{a.address}</td>
                <td>
                  <Button
                    variant="warning"
                    size="sm"
                    onClick={() => this.handleShowModal(a)}
                  >
                    Edit
                  </Button>{" "}
                  <Button
                    variant="danger"
                    size="sm"
                    onClick={() => this.handleDelete(a.id)}
                  >
                    Delete
                  </Button>
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={6} className="text-center text-muted">
                  No bank accounts found.
                </td>
              </tr>
            )}
          </tbody>
        </Table>

        <Modal show={showModal} onHide={this.handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>
              {currentAccount.id ? "Edit Bank Account" : "Add Bank Account"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form onSubmit={(e) => e.preventDefault()}>
              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Bank Name</Form.Label>
                    <Form.Control
                      name="bankName"
                      value={currentAccount.bankName || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Name</Form.Label>
                    <Form.Control
                      name="accountName"
                      value={currentAccount.accountName || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>Account Number</Form.Label>
                    <Form.Control
                      name="accountNumber"
                      value={currentAccount.accountNumber || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>IFSC Code</Form.Label>
                    <Form.Control
                      name="ifsccode"
                      value={currentAccount.ifsccode || ""}
                      onChange={this.handleChange}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Form.Group className="mb-3">
                <Form.Label>Address</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={3}
                  name="address"
                  value={currentAccount.address || ""}
                  onChange={this.handleChange}
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              type="button"
              onClick={this.handleCloseModal}
            >
              Cancel
            </Button>
            <Button variant="primary" type="button" onClick={this.handleSave}>
              Save
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
